import React from "react";
import { Link } from 'react-router-dom';


const UserCompanyField = ({ company, subcontractor }) => (
    subcontractor?.id ? <Link to={ `/subcontractors/${ subcontractor?.id }` }> { subcontractor?.title }</Link> : company ?? <strong>&mdash;</strong>
);

export default UserCompanyField;